import { createClient } from "@sanity/client";

const sanityClient = createClient({
  projectId: "krjmu28b",
  dataset: "production",
  apiVersion: "2023-10-19",
  useCdn: true,
});

export default sanityClient;
